<mat-select
  class="full-width"
  matInput
  [disabled]="disabled"
  [placeholder]="placeholder"
  [formControl]="formControl"
  (selectionChange)="ngOnChanges([])"
  >
  <mat-select-trigger><i [class]="formControl.value"></i></mat-select-trigger>
  @for (option of options; track option) {
    <mat-option [value]="option"
      ><i [class]="option"></i
    ></mat-option>
  }
</mat-select>
